import { createContext } from 'react';

export const CardContext = createContext({
  triggered: false,
  scrollToBottom: false,
  onTriggerClick: null
});
